/**
 * AURUM Finance — FAQ Accordion
 * Toggle open/close on FAQ items
 */
(function () {
  document.querySelectorAll('.faq-question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = this.closest('.faq-item');
      var icon = this.querySelector('.faq-icon');
      var answer = item.querySelector('.faq-answer');
      var wasActive = item.classList.contains('active');

      // Close all
      document.querySelectorAll('.faq-item').forEach(function (fi) {
        fi.classList.remove('active');
        var ic = fi.querySelector('.faq-icon');
        var ans = fi.querySelector('.faq-answer');
        if (ic) ic.textContent = '+';
        if (ans) ans.style.maxHeight = '0';
      });

      // Toggle current
      if (!wasActive) {
        item.classList.add('active');
        if (icon) icon.textContent = '−';
        if (answer) answer.style.maxHeight = answer.scrollHeight + 24 + 'px';
      }
    });
  });
})();
